import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-close-thin",
  "use": "app-icon-close-thin-usage",
  "viewBox": "0 0 28 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 27\" id=\"app-icon-close-thin\"><g fill=\"#D8D8D8\" fill-rule=\"evenodd\"><path d=\"M3.04.314L27.08 24.355l-2.12 2.122L.918 2.435z\" /><path d=\"M27.081 2.435L3.04 26.477.919 24.355 24.96.314z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol